import React, { useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { UserContext } from "../../configs/UserContext";
import ReCAPTCHA from "react-google-recaptcha";
import { captchaSiteKey } from "../../configs/auth";
const { loginMethod } = require('../../configs/auth');



function Login() {

    const [showPassword, setShowPassword] = useState(false);
    const [ loginData, setLoginData ] = useState({
        email: '',
        password: ''
    });
   
    const [error, setError] = useState(false);
    const navigate = useNavigate();
    const { setUser } = useContext(UserContext);
    const reCaptchaRef = useRef();

    const handleLogin = async (e) => {
        e.preventDefault();
        try{
            const token = await reCaptchaRef.current.executeAsync();
            const result = await loginMethod(loginData, token);
            reCaptchaRef.current.reset();
            if (result.success) {
                setUser(result.role);
                setError(false);
                if(result.role === 'admin'){
                    navigate('/admin/adminsettings');
                } else if(result.role === 'user'){
                    navigate('/account');
                }
            } else {
            // Hibakezelés
            setError(true);
            }
        } catch (error) {
            console.error(error);
        }
    };
    const handleChange = (e) => {
        const { id, value } = e.target;
        setLoginData((prevData) => ({
            ...prevData,
            [id]: value
        }));
    };

    return (
        <div className="container-fluid d-flex justify-content-center align-items-center p-0">
            <div className='col-lg-5 col-md-9 col-11 my-5 p-4 d-flex flex-column justify-content-center align-items-center border shadow'>

                <h4 className="mb-4">Bejelentkezés</h4>

                <form className='d-flex flex-column align-items-center col-lg-7 col-10'>

                    <div className="form-floating mb-3">

                        <input type="email" className={`form-control ${error ? 'border border-1 border-danger' : ''}`} id="email" placeholder="" value={loginData.email} onChange={handleChange} required/>

                        <label htmlFor="email">Email cím</label>

                    </div>

                    <div className="form-floating mb-2">

                        <input type={showPassword ? 'text' : 'password'} className={`form-control ${error ? 'border border-1 border-danger' : ''}`} id="password" placeholder="" minLength='8' value={loginData.password} onChange={handleChange} required />
                        <label htmlFor="password">Jelszó</label>
                        <span
                            className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                            onClick={() => setShowPassword(prevState => !prevState)}
                        >
                            <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true"></i>
                        </span>

                    </div>
                    
                    <ReCAPTCHA
                        sitekey={captchaSiteKey}
                        size="invisible"
                        ref={reCaptchaRef}
                    />

                    <div className={`d-flex justify-content-start ${error ? 'd-inline' : 'd-none'}`}>
                        <p className="m-0 text-danger">Hibás email cím vagy jelszó!</p>
                    </div>

                    <div className="col-12 d-flex justify-content-center">
                        <button className='btn btn-home-primary my-2' onClick={(e)=>handleLogin(e)}>Bejelentkezés</button>
                    </div>
                    
                    
                </form>

                <div className="text-center mb-3">
                    <Link to="/forgot_password" className="text-decoration-none text-primary">
                        Elfelejtetted a jelszavad?
                    </Link>
                </div>
                

                <div className='d-flex flex-row'>
                    <h6 className='m-0 me-2'>Nincs még fiókod?</h6>
                    <Link to='/registration'>Itt tudsz regisztrálni</Link>
                </div>
            </div>
        </div>

    );
}

export default Login;